const r = {
  name: "ll-custom-render",
  props: {
    render: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    return () => e.render();
  }
};
export {
  r as default
};
//# sourceMappingURL=CustomRender.js.map
